const colorVariants = {
  blue: "bg-blue-500",
  green: "bg-emerald-500",
  purple: "bg-purple-500",
  amber: "bg-amber-500",
  red: "bg-red-500",
  teal: "bg-teal-500",
};

const SectionDivider = ({
  icon: Icon,
  title,
  color = "blue",
  className = "",
  lineClassName = "",
  titleClassName = "",
  iconClassName = "",
}) => {
  return (
    <div className={`flex items-center gap-2 mb-4 ${className}`}>
      {/* ICON */}
      {Icon && (
        <div
          className={`
                        p-1.5 rounded-lg shadow-sm shrink-0
                        ${colorVariants[color] || colorVariants.blue}
                    `}
        >
          <Icon className={`w-3.5 h-3.5 text-white ${iconClassName}`} />
        </div>
      )}

      {/* TITLE */}
      <span
        className={`
                    text-xs font-bold uppercase tracking-wider
                    text-slate-900 dark:text-white whitespace-nowrap
                    ${titleClassName}
                `}
      >
        {title}
      </span>

      {/* LINE */}
      <div
        className={`flex-1 h-px bg-slate-700 dark:bg-slate-400 ${lineClassName}`}
      />
    </div>
  );
};

export default SectionDivider;
